export default "__VITE_ASSET__DNVBQ9c9__"